import { LayoutGrid } from "./LayoutContainers";
import Stats from "./Stats";
import { __ } from "../locales/translation";

function StatsGrid({ moneda, data }) {
    const { precioCierreAnterior, precioApertura, precioMinimo, precioMaximo, montoOperado } = data || {};

    return (
        <div className="cot-stats-grid">
            <Stats title={__("Cierre anterior")} currency={moneda} value={precioCierreAnterior} />
            <Stats title={__("Apertura")} currency={moneda} value={precioApertura} />
            <Stats title={__("Mínimo")} currency={moneda} value={precioMinimo} />
            <Stats title={__("Máximo")} currency={moneda} value={precioMaximo} />
            <Stats title={__("Volumen")} currency={moneda} value={montoOperado} />
        </div>
    );
}

export default function StatsRow({ isLoading = false, data }) {
    return (
        <div className="cot-stats-row">
            <LayoutGrid spacingTop="0" spacingBottom="0" cols={1}>
                <StatsGrid data={data} />
            </LayoutGrid>
        </div>
    );
}
